import { combineReducers } from "redux";
import overlayReducer from "./overlay/reducer";
import cameraReducer from "./camera/reducer";

const reducers = combineReducers({
  "overlayState": overlayReducer,
  "cameraState": cameraReducer
})

export default reducers;
export type State = ReturnType<typeof reducers>